import React from 'react';
import { useThemeMode } from '../../contexts/ThemeContext';
// Logo oficial branco+vermelho (SVG) para fundos escuros; colorida (PNG) para claro.
import logoWhite from '../../assets/images/logoLegalOpsWhiteRed.svg';
import logoColor from '../../assets/images/logoLegalOpsColor.png';

interface Props extends React.ImgHTMLAttributes<HTMLImageElement> {
    /** Força uma variante (ex.: telas externas dark-only usam 'white'). */
    forceVariant?: 'white' | 'color';
}

/**
 * Logo do Legal Ops que alterna automaticamente entre as versões
 * branca (tema escuro) e vermelha/preta (tema claro). Reativo ao toggle de tema.
 */
export default function LogoLegalOps({ forceVariant, alt = 'EasyJur Legal Ops', style, ...rest }: Props) {
    const { isDark } = useThemeMode();
    const variant = forceVariant ?? (isDark ? 'white' : 'color');
    const src = variant === 'white' ? logoWhite : logoColor;
    return (
        <img
            src={src}
            alt={alt}
            style={{ objectFit: 'contain', display: 'block', ...style }}
            {...rest}
        />
    );
}
